<template>
  <div>
    <MiniButton class="mb-2">
      {{ member.department ? member.department.name : '-' }}
    </MiniButton>
    <div class="d-flex align-items-center mb-2">
      <UserAvatar
        :user="member"
        size="sm"
        class="mr-2" />
      <div>
        <div class="d-flex align-items-center">
          <span
            :class="{ 'record-list-member-info__name--highlighted': highlighted }"
            class="font-weight-bold fs-m">{{ member.name }}</span>
          <span
            v-if="showSortNo"
            class="fs-s ml-1 text--grey05">{{ member.sortNo }}</span>
        </div>
        <div class="d-flex align-items-center flex-wrap mt-1">
          <UserTag
            v-if="member.tag1 || member.tag2"
            :user="member"
            class="mr-1" />
          <span
            v-if="member.finalDestination || member.position"
            class="record-list-member-info__position">
            {{ member.finalDestination ? member.finalDestination.destinationName : member.position }}
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="studentNumberText"
      class="record-list-member-info__student-number">
      {{ studentNumberText }}
    </div>
  </div>
</template>

<script>
import { getStudentNumberText } from '@/helper/profile'
import MiniButton from '@/components/parts/MiniButton.vue'
import UserAvatar from '@/components/parts/UserAvatar.vue'
import UserTag from '@/components/parts/UserTag.vue'

export default {
  components: {
    MiniButton,
    UserAvatar,
    UserTag,
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
    showSortNo: {
      type: Boolean,
      default: false,
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    studentNumberText() {
      return getStudentNumberText(this.member)
    },
  },
}
</script>

<style lang="scss" scoped>
.record-list-member-info {
  &__student-number {
    border: 1px dashed $grey08;
    padding: 4px 8px;
    font-size: $fs-s;
    border-radius: 2px;
    margin-top: 4px;
  }

  &__position {
    font-size: $fs-s;
    color: $grey05;
    margin-top: 2px;
    word-break: break-all;
  }

  &__name--highlighted {
    border-bottom: 2px solid $l-blue;
  }
}
</style>
